import Backbone from 'backbone'
import template from './upload-users-form.hbs'
import FormView from 'scoreboard/components/form-view'
import _ from 'lodash'
import Xhr from 'scoreboard/components/xhr'
import i18n from 'scoreboard/components/i18n'
import highlight from 'scoreboard/components/highlight'
import FileDrop from 'scoreboard/components/files/file-drop'

var UploadForm = Backbone.View.extend({

	className: 'simple-import-form',

	events: {
		'click .import-example-download': '_onDownloadExample'
	},

	initialize: function(options) {
		this.options = options
	},

	render: function () {
		let appAdminLink = '<a class="sp-navigate" href="admin/app">'
			+ i18n.get('admin.appConfiguration.applicationConfiguration') + '</a>'
		let multipleGroupsInstructions = i18n.get(
			'admin.import.instructions.user.multipleGroups',
			highlight(i18n.get('admin.import.instructions.user.multipleGroups.example')))

		this.$el.html(template({
			titleInstructions: i18n.get('admin.import.instructions.user.title', appAdminLink),
			multipleGroupsInstructions
		}))

		this.formView = new FormView({ el: this.el })
		this._renderFileDrop()
		this._renderWizard()
		this._attachListeners()
		this.formView.start()

		return this
	},

	_renderFileDrop() {
		this.fileDrop = new FileDrop({
			animated: true,
			fileUploaderOptions: {
				url: 'api/admin/users/import/validate',
				dataFn: _.constant({}),
				accept: ['csv']
			}
		})

		this.$('.dialog-body-content .import-file').after(this.fileDrop.el)
		this.fileDrop.render()
	},

	_renderWizard() {
		this.options.wizard.render({
			formView: this.formView,
			doneKey: 'admin.import'
		})
	},

	_attachListeners() {
		this.fileDrop.on('start', data => this._handleFileDropStart(data))
			.on('done', data => this._onUploadFinished(data))
			.on('error', xhr => this.onUploadError(xhr))
	},

	_handleFileDropStart() {
		this.formView.primaryButton.loading()
		this._onUploadStart()
	},

	_onDownloadExample() {
		new Xhr().download({url: 'api/admin/users/import/users_example.csv'})
	},

	_onUploadStart: function(data) {
		this.$('.import-file .label-text').toggleClass('is-not-displayed', true)
	},

	_onUploadFinished: function (data) {
		this.options.wizard.next({ preview: {data}, files: this.fileDrop.getFiles() })
		this.reset()
	},

	onUploadError: function(xhr) {
		if (typeof xhr == 'string') {
			xhr.statusText = xhr
		}

		if (xhr.statusText !== 'abort') {
			this.formView.error(xhr)
		}
	},

	reset: function () {
		_.invokeMap([this.wizardProgress, this.fileDrop, this.formView], 'remove')
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		this.reset()
	}
})

export default UploadForm

UploadForm.__filename__ = 'admin/principals/users/import/upload-users-form.js'
